import { withOneTrust } from '@segment/analytics-consent-wrapper-onetrust';
import { AnalyticsBrowser, type InitOptions } from '@segment/analytics-next';

export const analytics = new AnalyticsBrowser();

if (typeof window !== 'undefined') {
  const writeKey = window.__CHIME_CONFIG__?.segmentWriteKey;
  if (writeKey) {
    // Use Fetch `keepalive` so events fired immediately before navigation still reach Segment.
    // https://www.twilio.com/docs/segment/connections/sources/catalog/libraries/website/javascript#keepalive
    withOneTrust(analytics).load({ writeKey }, {
      integrations: {
        'Segment.io': {
          deliveryStrategy: {
            strategy: 'batching',
            config: {
              keepalive: true,
            },
          },
        },
      },
    });
  }
}
